// Color swatch picker for product pages. The swatches replace the Color
// dropdown visually; the select stays in the DOM (hidden) and the swatches
// drive it, so all variant logic listening for select changes keeps working.
// Delegated from document so swatches inside quick-add modal content
// injected after page load work too.
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-swatch-value]');
    if (!swatch) return;

    var wrapper = swatch.closest('.product-form__input--color-swatches');
    if (!wrapper) return;

    var select = wrapper.querySelector('select');
    if (!select) return;

    var value = swatch.getAttribute('data-swatch-value');
    if (select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    wrapper.querySelectorAll('[data-swatch-value]').forEach(function (el) {
      var selected = el === swatch;
      el.classList.toggle('color-swatch--selected', selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var label = wrapper.querySelector('[data-swatch-selected-label]');
    if (label) label.textContent = value;
  });
})();
